class CartNotificationRecommended extends HTMLElement {
  constructor() {
    super();
    this.initCheckboxHandlers();
    this.initCheckboxHandlerOnClose();
  }

  initCheckboxHandlers() {
    const checkboxes = this.querySelectorAll(".cart-notification-checkbox");
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
  }

  initCheckboxHandlerOnClose(){
    const closeButton = document.getElementById("cart-notification-close-button");
    closeButton.addEventListener("click", this.deselectCheckboxOnClose.bind(this));
  }

async deselectCheckboxOnClose() {
    const checkboxes = this.querySelectorAll(".cart-notification-checkbox");
    for (const checkbox of checkboxes) {   
        const variantId = checkbox.getAttribute("data-variant-id");
        checkbox.checked = false;
        await this.removeFromCart(variantId);
    }
}

  async handleCheckboxChange(event) {
    const cartIconValue = parseInt(document.getElementById("recommended-cart-icon-bubble-value").textContent, 10);
    const checkbox = event.target;
    const variantId = checkbox.getAttribute("data-variant-id");

    if (checkbox.checked) {
      let newValue = cartIconValue + 1;
      document.getElementById("recommended-cart-icon-bubble-value").textContent = `${newValue}`;
      await this.addToCart(variantId);
    } else {
      let newValue = cartIconValue - 1;
      document.getElementById("recommended-cart-icon-bubble-value").textContent = `${newValue}`;
      await this.removeFromCart(variantId);
    }
  }

  async addToCart(variantId) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(variantId),
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error("Fehler beim Hinzufügen zum Warenkorb");
      }

      const cartData = await response.json();
      this.updateCartCount(cartData.items.length);

      this.showNotification("Produkt wurde zum Warenkorb hinzugefügt");
    } catch (error) {
      console.error("Fehler:", error);
      checkbox.checked = false;
      this.showNotification("Fehler beim Hinzufügen zum Warenkorb", "error");
    }
  }

  async removeFromCart(variantId) {
    try {
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();

      const itemToRemove = cartData.items.find(
        (item) => item.variant_id === parseInt(variantId)
      );

      if (itemToRemove) {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: itemToRemove.key,
            quantity: 0,
          }),
        });

        if (!response.ok) {
          throw new Error("Fehler beim Entfernen aus dem Warenkorb");
        }

        const updatedCartData = await response.json();
        this.updateCartCount(updatedCartData.item_count);

        this.showNotification("Produkt wurde aus dem Warenkorb entfernt");
      }
    } catch (error) {
      console.error("Fehler:", error);
      this.showNotification("Fehler beim Entfernen aus dem Warenkorb", "error");
    }
  }

  updateCartCount(count) {
    const cartCount = document.querySelector(".cart-count");
    if (cartCount) {
      cartCount.textContent = `${count} ${
        count === 1 ? "Produkt" : "Produkte"
      }`;
    }
  }

  showNotification(message, type = "success") {
    console.log(`${type}: ${message}`);
  }
}

customElements.define(
  "cart-notification-recommended",
  CartNotificationRecommended
);
